import React from 'react';
import Amplify, { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import Profile from './profile';
import Affiliate from './affiliate';
import ProfileBusiness from './profileBusiness';
import * as SecretKeys from '../../ENV.json';

import {
  getSettlemetEnrichmentQuestion,
  getAllSettlement,
  getEnrollSettlementForUser,
  getAlLFeatureSettlement,
} from '../../Actions/actions';

Amplify.configure(SecretKeys.awsUserpool);

class ProfileContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UserRole: localStorage.getItem('roleName'),
    };
    this.logout = this.logout.bind(this);
  }

  componentWillMount() {
    if (localStorage.getItem('paymentStatus') === 'pending'
        && !!localStorage.getItem('paymentFailedButLetUserIn') === false) {
      this.context.router.history.push('/add-payment-method');
    }
    // if (localStorage.getItem('paymentStatus') === 'pending') {
    //   localStorage.clear();
    //   Auth.signOut().then(async () => {
    //     await this.props.logoutUser();
    //     this.props.clearDataEmail();
    //     this.context.router.history.push('/');
    //   }).catch(error => error);
    // }
  }

  /**
   * Get Settlements
   */
  componentDidMount() {
    this.props.getAllSettlement({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: 'unknown',
    });
  }

  logout() {
    Auth.signOut()
      .then(() => {
        localStorage.clear();
        this.context.router.history.push('/');
      })
      .catch(error => error);
  }

  render() {
    const { UserRole } = this.state;
    return (
      <div className="container">
        <span />
        <div className="main-content">
          {UserRole === 'Consumer' ? (
            <Profile />
          ) : UserRole === 'Affiliate' ? (
            <Affiliate />
          ) : (
            <ProfileBusiness />
          )}
        </div>
      </div>
    );
  }
}

ProfileContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSettlemetEnrichmentQuestion,
      getAllSettlement,
      getEnrollSettlementForUser,
      getAlLFeatureSettlement,
    },
    dispatch,
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ProfileContainer),
);
